<button *ngIf="isShow" (click)="scrollToTop()" class="back-to-top-btn">
  <span>{{ 'common.back-to-top' | cxTranslate }}</span>
  <i class="fa fa-arrow-up"></i>
</button>
